// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.css\"","body2":"_3SZbtBhXKsMgrIDYFmK8U","mainSectionTitle":"TVxPGk0Lff02sqq8MHQv3 _3SZbtBhXKsMgrIDYFmK8U"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/help/main-section-content/MainSectionContent.css
// module id = 1133
// module chunks = 2